import { memo, useCallback, useMemo, useState } from 'react';

import { Collapse } from '@material-ui/core';

import { ToggleCollapseProps } from './toggleCollapse.types';

export const ToggleCollapse = memo(
  ({ expanded: controlledExpanded, unmountOnExit, classes, collapsedView, expandedView }: ToggleCollapseProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const expanded = useMemo(() => controlledExpanded ?? isExpanded, [controlledExpanded, isExpanded]);

    const handleToggle = useCallback(() => {
      if (controlledExpanded !== undefined) {
        return;
      }

      setIsExpanded(prev => !prev);
    }, [controlledExpanded]);

    return (
      <div className={classes?.root}>
        <Collapse in={!expanded} unmountOnExit={unmountOnExit?.collapsed}>
          {collapsedView(handleToggle)}
        </Collapse>

        <Collapse in={expanded} unmountOnExit={unmountOnExit?.expanded}>
          {expandedView(handleToggle)}
        </Collapse>
      </div>
    );
  },
);
